/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailBankSendPasswordResetEmailRequest
 */
export interface MailBankSendPasswordResetEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof MailBankSendPasswordResetEmailRequest
     */
    info?: string;
}

/**
 * Check if a given object implements the MailBankSendPasswordResetEmailRequest interface.
 */
export function instanceOfMailBankSendPasswordResetEmailRequest(value: object): value is MailBankSendPasswordResetEmailRequest {
    return true;
}

export function MailBankSendPasswordResetEmailRequestFromJSON(json: any): MailBankSendPasswordResetEmailRequest {
    return MailBankSendPasswordResetEmailRequestFromJSONTyped(json, false);
}

export function MailBankSendPasswordResetEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailBankSendPasswordResetEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'info': json['info'] == null ? undefined : json['info'],
    };
}

export function MailBankSendPasswordResetEmailRequestToJSON(json: any): MailBankSendPasswordResetEmailRequest {
    return MailBankSendPasswordResetEmailRequestToJSONTyped(json, false);
}

export function MailBankSendPasswordResetEmailRequestToJSONTyped(value?: MailBankSendPasswordResetEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'info': value['info'],
    };
}

